<template>
  <!--clickable v-close-popup -->
  <q-item clickable :class="classNotification(notification.s)"
    @click="() => $emit('change', { key: notification.date, notification })">
    <q-item-section avatar>
      <q-avatar color="primary" text-color="white" :icon="icon" />
    </q-item-section>
    <q-item-section>
      <q-item-label>{{ notification.t }}</q-item-label>
      <q-item-label caption>{{ textHTML }}</q-item-label>
      <q-item-label v-if="notification.l" @click="() => {
        $router.push({
          path: notification.l,
          params: { reload: true },
          force: true,
          reload: true,
        })
      }"><small><b>[ {{ $gettext('LINK') }} ]</b></small></q-item-label>
      <q-item-label caption v-if="isSubText" @click="() => { expansor = !expansor }"
        class="bg-grey-2 text-primary rounded-borders row flex-center q-mt-md">
        <q-icon text-color="primary" :name="expansor ? 'arrow_drop_up' : 'arrow_drop_down'" size="10px"
          class="pdn-shrink-toggle" />
      </q-item-label>
    </q-item-section>
    <q-item-section side top>
      <q-avatar icon="cancel" @click="() => $emit('delete', { key: notification.date, notification })" />
      <q-item-label caption>{{ dateText }}</q-item-label>
    </q-item-section>
  </q-item>
</template>
<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import moment from 'moment'

@Component({
  name: 'Notification-Item',
  components: {},
  props: {
    notification: Object,
    date: Number
  }
})
export default class NotificationItem extends Vue {
  sizeText = 40;
  expansor = false

  get icon () {
    switch (this.notification.y) {
      case 1:
        return 'settings'
      case 2:
        return 'description'
      case 3:
        return 'report_problem'
      default:
        return 'notifications'
    }
  }

  get dateText () {
    const d = moment(parseInt(this.notification.date))
    var duration = moment.duration(moment().diff(d))
    duration.locale(navigator.language || navigator.userLanguage)
    return duration.humanize({ round: 'seconds' })
  }

  get text () {
    return this.notification.m || ''
  }

  get textHTML () {
    return !this.expansor && this.isSubText ? this.text.substring(0, this.sizeText) + '...' : this.text
  }

  get isSubText () {
    return this.text.length > this.sizeText
  }

  classNotification (s) {
    return s == 1 ? 'notification-new' : 'notification'
  }
}
</script>
<style lang="stylus" scoped>
@import '~quasar-variables';

.notification-offline {
  font-size: 30px;
  color: black;
}

.notification-online {
  font-size: 30px;
  color: red;
}

.notification {
  background-color: white;
  width: 300px;
}

.notification-new {
  background-color: #ddd;
  width: 300px;
}
</style>
